import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
    {
        num: "01",
        title: "Comece pelo orçamento",
        text: "Nenhum investimento salva quem não sabe para onde o dinheiro vai. Antes de falar em rentabilidade, damos nome e destino a cada real que entra na sua conta.",
    },
    {
        num: "02",
        title: "Proteja-se primeiro",
        text: "A reserva de emergência vem antes de qualquer ação, fundo ou criptomoeda. Segurança não é conservadorismo — é a licença para arriscar no resto.",
    },
    {
        num: "03",
        title: "Invista com método",
        text: "Nada de dica quente, promessa de lucro rápido ou gráfico piscando. Aportes constantes em ativos que você entende, repetidos por anos, vencem qualquer aposta.",
    },
    {
        num: "04",
        title: "Deixe o tempo trabalhar",
        text: "Os juros compostos são a única mágica real das finanças — e cobram apenas uma moeda: paciência. Quem começa cedo precisa de menos dinheiro, não de mais sorte.",
    },
];

export const Manifesto = () => (
    <section id="manifesto" data-testid="manifesto-section" className="border-t border-white/10 bg-paper">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-32">
            <Reveal>
                <span className="text-xs uppercase tracking-[0.3em] text-gold font-medium">Manifesto</span>
                <h2 className="font-serif text-3xl md:text-5xl tracking-tight mt-3 max-w-2xl leading-tight">
                    Quatro princípios. <span className="italic text-slate-400">Nenhum atalho.</span>
                </h2>
            </Reveal>

            <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14 md:gap-y-20">
                {CHAPTERS.map((c, i) => (
                    <Reveal key={c.num} delay={i * 0.08}>
                        <div data-testid={`manifesto-chapter-${c.num}`} className="relative flex gap-6 md:gap-8">
                            <span className="font-serif text-6xl md:text-8xl leading-none text-white/[0.08] select-none -mt-2">
                                {c.num}
                            </span>
                            <div className="pt-1 md:pt-3">
                                <h3 className="font-serif text-xl md:text-2xl tracking-tight mb-3">{c.title}</h3>
                                <p className="text-sm md:text-base text-slate-400 leading-relaxed">{c.text}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
